import React, {useState, useEffect} from "react"
import {graphql} from "gatsby"
import styled  from "styled-components"
import Seo from "../components/Seo"
// style
import Intro from '../components/Intro'
import Footer from '../components/Footer'
import ProjectList from '../components/ProjectList'
import {useInView} from 'react-intersection-observer'

const HomepageWrapper = styled.div`
  color: var(--darkBlue);
`;

const HomePage = React.memo(({ data, location }) => {
  // const disabledAnimation = location.fromPost ? true : false;
  const [introRef, introInView] = useInView({
    triggerOnce: true,
  });
  const [wasOnceVisible, setWasOnceVisible] = useState(false);
  useEffect(() => {
      if (introInView === true) {
          setWasOnceVisible(true);
      } 
  }, [introInView]);

  return (
    <HomepageWrapper>
      <Seo title="Portfolio" />
      <Intro innerRef={introRef} location={location} />

      <ProjectList data={data} location={location} introInView={wasOnceVisible} />
     
      <Footer />
    
      </HomepageWrapper>
 
  )
});

export default HomePage

export const pageQuery = graphql`{
  site {
    siteMetadata {
      title
    }
  }
  allMdx(
    filter: {fields: {collection: {eq: "projects"}}}
    sort: {fields: [frontmatter___date], order: DESC}
  ) {
    edges {
      node {
        excerpt
        fields {
          slug
        }
        frontmatter {
          date(formatString: "YYYY")
          title
          tagline
          type
          background
          link
          logo {
            publicURL
          }
          web {
            publicURL
          }
          description
          cover {
            childImageSharp {
              gatsbyImageData(width: 800)
            }
          }
          cover2 {
            childImageSharp {
              gatsbyImageData(width: 800)
            }
          }
        }
      }
    }
  }
}
`
